import { Flex, Text, Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import Field from "ui/components/Input/Field";
import { useForm } from "react-hook-form";
import SelectContaBancaria from "ui/components/Input/SelectContaBancaria";
import ButtonAnexarArquivos from "ui/components/Button/ButtonAnexarArquivos";
import { useEffect } from "react";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import useSaveConciliacaoBancaria from "core/features/conciliacao-bancaria/hooks/useSaveConciliacaoBancaria";
import { ImportarOfxForm } from "core/features/conciliacao-bancaria/typings";

interface FormModalProcessarArquivosProps {
  visible?: boolean;
  onClose: () => any;
  onSuccess?: () => any;
}

export default function FormModalProcessarArquivos({
  onClose,
  visible,
  onSuccess,
}: FormModalProcessarArquivosProps) {
  const { control, handleSubmit, reset } = useForm<ImportarOfxForm>();

  const { mutate: handleSave, isLoading } = useSaveConciliacaoBancaria();

  useEffect(() => {
    if (!visible) {
      reset({});
    }
  }, [reset, visible]);

  const _handleSave = (form: ImportarOfxForm) => {
    handleSave(form, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess().then(onSuccess);
      },
    });
  };

  return (
    <form>
      <Text as="h3" fontSize={20} fontWeight="500" mb="15px">
        Processar arquivos
      </Text>
      <Box as={Row} gutter={16} mb={12}>
        <Box as={Col} sm={14}>
          <Field
            shouldUnregister
            label="Conta bancária"
            control={control}
            name="tenantContaId"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <SelectContaBancaria
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
                markerDefault
                incluirInativas={false}
              />
            )}
          />
          <Text fontSize="12px" mt={2}>
            *Arquivo para conciliação(*.OFC, *.OFX, *.RET )
          </Text>
        </Box>

        <Box mt={5} as={Col} sm={8}>
          <Field
            control={control}
            name="file"
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <ButtonAnexarArquivos
                accept=".ofx, .ofc, .ret"
                fileName={field.value?.name}
                multiple={false}
                variant="outline"
                onAnexar={(files) => {
                  field.onChange(files!?.[0]);
                }}
              />
            )}
          />
        </Box>
      </Box>

      <Flex flex={1} justifyContent="end" gap={4}>
        <OutlineButton onClick={onClose}> Fechar</OutlineButton>
        <PrimaryButton
          onClick={handleSubmit(_handleSave)}
          isLoading={isLoading}
        >
          Enviar Arquivos
        </PrimaryButton>
      </Flex>
    </form>
  );
}
